import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export class Pagination extends PureComponent {
  constructor(props) {
    super(props)
    const {
      params: { pageCount },
    } = props
    this.state = { currentPageCount: pageCount || 0 }
  }

  onClick = type => {
    const { onClickHandler, params } = this.props
    const { currentPageCount } = this.state
    const pageCount = type === 'next' ? currentPageCount + 1 : currentPageCount - 1
    this.setState({ currentPageCount: pageCount }, () => {
      onClickHandler({ ...params, pageCount })
    })
  }

  clickNext = () => this.onClick('next')

  clickPrev = () => this.onClick('prev')

  render() {
    const { currentPageCount } = this.state
    const { hasNextPage } = this.props
    const hideBoth = currentPageCount < 1 && !hasNextPage
    if (hideBoth) return null
    return (
      <div className='tc mt4'>
        <button disabled={currentPageCount < 1} onClick={this.clickPrev}>
          Prev
        </button>
        <button disabled={!hasNextPage} onClick={this.clickNext}>
          Next
        </button>
      </div>
    )
  }
}

export default Pagination

Pagination.propTypes = {
  onClickHandler: PropTypes.func,
  params: PropTypes.shape({}),
  hasNextPage: PropTypes.bool,
}

Pagination.defaultProps = {
  onClickHandler: () => {},
  params: {},
  hasNextPage: false,
}
